import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const root = ReactDOM.createRoot(document.getElementById('root'));

const theme = createTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: 'inherit', // Оригинальный цвет текста
            WebkitTextFillColor: 'inherit', // Для Safari
            opacity: 1, // Убирает прозрачность
            '&:before': {
              borderBottomStyle: 'solid !important', // Убирает пунктирную линию
            },
            '& .MuiInputBase-input': {
              opacity: 1, // Убирает прозрачность для input
              color: 'inherit', // Оригинальный цвет
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.23)', // Стандартный цвет границы
            },
            '& .MuiInputBase-input': {
              opacity: 1,
              WebkitTextFillColor: 'inherit',
            },
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: 'transparent', // Убирает серый фон
            '&:hover': {
              backgroundColor: 'transparent', // Убирает hover-эффект
            },
            '& .MuiInputBase-input': {
              opacity: 1,
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          '&.Mui-disabled': {
            color: 'inherit', // Цвет иконки как у обычного Select
            opacity: 1,
          },
        },
      },
    },
  },
});

root.render(
  <Provider store={store}>
    <Router>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={theme}>
          {' '}
          <App />
        </ThemeProvider>
      </LocalizationProvider>
    </Router>
  </Provider>,
);
